// ============================================================
// qty-table.js - Customized for Seal Subscription + Bulk Pricing
// Uses text-based DOM search (NOT Seal CSS selectors)
// %kriz customize
// ============================================================
//
// ARCHITECTURE:
// 1. IIFE #1: Custom Elements (QtyInputEl, QtyTableFormEl, QtyTableEl)
//    - These work IF <qty-table>, <qty-table-form>, <qty-table-input> exist in DOM
//    - On some live environments, these custom elements are NOT rendered
//
// 2. IIFE #2: FALLBACK - Document-level event delegation
//    - Works regardless of whether custom elements exist
//    - Queries BOTH "qty-table tbody tr" AND ".gridiscstbl tbody tr"
//    - This is the PRIMARY mechanism on the live site
// ============================================================

// ============================================================
// IIFE #1: Custom Elements (kept for backward compatibility)
// ============================================================
(function () {
  // ---- Helper: Find subscription discount % from page text ----
  function getSubscriptionDiscount() {
    // Method 1: From data attribute on qty-table (if it exists)
    var qtyTable = document.querySelector('qty-table[data-subscription-discount]');
    if (qtyTable) {
      var discount = parseFloat(qtyTable.getAttribute('data-subscription-discount')) || 0;
      if (discount > 0) return discount / 100;
    }

    // Method 1b: From data attribute on .gridiscstbl wrapper (if it exists)
    var gridWrapper = document.querySelector('.gridiscstbl[data-subscription-discount]');
    if (gridWrapper) {
      var discount = parseFloat(gridWrapper.getAttribute('data-subscription-discount')) || 0;
      if (discount > 0) return discount / 100;
    }

    // Method 2: Search page text for "SAVE 10%"
    if (document.body) {
      var match = document.body.textContent.match(/SAVE\s+(\d+)%/i);
      if (match) return parseInt(match[1], 10) / 100;
    }

    // Default fallback: 10%
    return 0.10;
  }

  // ---- Helper: Check if subscription is currently active ----
  function isSubscriptionActive() {
    var sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value && sellingPlanInput.value !== '' && sellingPlanInput.value !== '0') {
      return true;
    }
    var sellingPlanSelect = document.querySelector('select[name="selling_plan"]');
    if (sellingPlanSelect && sellingPlanSelect.value && sellingPlanSelect.value !== '' && sellingPlanSelect.value !== '0') {
      return true;
    }
    return false;
  }

  // ---- Helper: Check if product has subscription option ----
  function hasSubscription() {
    var qtyTable = document.querySelector('qty-table[data-has-subscription]');
    if (qtyTable) {
      return qtyTable.getAttribute('data-has-subscription') === 'true';
    }
    // Fallback: check data attribute on .gridiscstbl wrapper
    var gridWrapper = document.querySelector('.gridiscstbl[data-has-subscription]');
    if (gridWrapper) {
      return gridWrapper.getAttribute('data-has-subscription') === 'true';
    }
    // Fallback: check if selling_plan input exists
    return !!document.querySelector('input[name="selling_plan"]');
  }

  // ---- Helper: Update a price span + Conversion Bear data attributes ----
  function updateMoneySpan(el, newPrice) {
    if (!el) return;
    var priceText = '$' + newPrice.toFixed(2);
    el.textContent = priceText;
    for (var i = 0; i < el.attributes.length; i++) {
      if (el.attributes[i].name.startsWith('data-currency-')) {
        el.setAttribute(el.attributes[i].name, priceText);
      }
    }
    el.setAttribute('data-currency-cad', priceText);
  }

  // ---- Cache: Arrays of Seal widget price elements ----
  var _cachedSubscriptionPriceEls = [];
  var _cachedOneTimePriceEls = [];
  var _cachedMainPriceEl = null;

  function findSealPriceElements() {
    // Determine if we need to search again (missing or detached)
    var needsSearch = _cachedSubscriptionPriceEls.length === 0 || 
                      _cachedSubscriptionPriceEls.some(function(el) { return !document.contains(el); }) ||
                      _cachedOneTimePriceEls.some(function(el) { return !document.contains(el); });
    if (!needsSearch) return;

    _cachedSubscriptionPriceEls = [];
    _cachedOneTimePriceEls = [];

    // Find main product price (NOT in Seal widget)
    _cachedMainPriceEl = document.querySelector('.product__price .price-item--sale') ||
                         document.querySelector('.product__price span.money') ||
                         document.querySelector('.product__price .money');

    // Strategy 1: Direct CSS class query
    document.querySelectorAll('.sls-one-time-price span.seal-money, .sls-one-time-price span.money, .sls-one-time-price .sls-price span').forEach(function(el) { _cachedOneTimePriceEls.push(el); });
    document.querySelectorAll('.sls-selling-plan-group-price:not(.sls-one-time-price) span.seal-money, .sls-selling-plan-group-price:not(.sls-one-time-price) span.money, .sls-selling-plan-group-price:not(.sls-one-time-price) .sls-price span').forEach(function(el) { _cachedSubscriptionPriceEls.push(el); });

    // Strategy 2: Use sls-option-container with sls-active vs without
    if (_cachedSubscriptionPriceEls.length === 0) {
      document.querySelectorAll('.sls-option-container.sls-active span.seal-money, .sls-option-container.sls-active span.money').forEach(function(el) { _cachedSubscriptionPriceEls.push(el); });
      document.querySelectorAll('.sls-option-container:not(.sls-active) span.seal-money, .sls-option-container:not(.sls-active) span.money').forEach(function(el) { _cachedOneTimePriceEls.push(el); });
    }

    // Strategy 3: Brute force - find seal-money spans and identify by parent class
    if (_cachedSubscriptionPriceEls.length === 0) {
      document.querySelectorAll('span.seal-money').forEach(function(span) {
        if (span === _cachedMainPriceEl) return;
        var parent = span.closest('.sls-one-time-price');
        if (parent) {
          if (!_cachedOneTimePriceEls.includes(span)) _cachedOneTimePriceEls.push(span);
        } else {
          var sealParent = span.closest('.sls-price-container') || span.closest('.sls-price');
          if (sealParent && !_cachedSubscriptionPriceEls.includes(span)) _cachedSubscriptionPriceEls.push(span);
        }
      });
    }

    // Strategy 4: Strict Sibling Crawler based on known Label Object
    if (_cachedSubscriptionPriceEls.length === 0 || _cachedOneTimePriceEls.length === 0) {
      var labels = document.querySelectorAll('.sls-selling-plan-group-name');
      
      labels.forEach(function(label) {
        var text = label.textContent.toLowerCase();
        var isSub = text.includes('subscribe');
        var isOt = text.includes('one-time') || text.includes('one time');
        if (!isSub && !isOt) return;

        var sibling = label.nextElementSibling;
        var foundPriceSpan = null;
        var depth = 0;
        
        while (sibling && depth < 3 && !foundPriceSpan) {
          if (sibling.tagName === 'DIV') {
            var innerSpans = sibling.querySelectorAll('span');
            for (var i = 0; i < innerSpans.length; i++) {
              var s = innerSpans[i];
              if (s.textContent.trim().match(/^\$\d/) && 
                  s !== _cachedMainPriceEl &&
                  !s.id.includes('sliderttl') &&
                  !s.classList.contains('sls-discount-badge')) {
                 foundPriceSpan = s;
                 break;
              }
            }
          }
          sibling = sibling.nextElementSibling;
          depth++;
        }

        if (foundPriceSpan) {
           if (isSub && !_cachedSubscriptionPriceEls.includes(foundPriceSpan)) _cachedSubscriptionPriceEls.push(foundPriceSpan);
           if (isOt && !_cachedOneTimePriceEls.includes(foundPriceSpan)) _cachedOneTimePriceEls.push(foundPriceSpan);
        }
      });
    }
  }

  // ---- Update Seal widget prices based on current tier ----
  function updateSealWidgetPrice(tierPrice) {
    if (!hasSubscription()) return;
    findSealPriceElements();

    var discount = getSubscriptionDiscount();
    var subPrice = discount > 0 ? tierPrice * (1 - discount) : tierPrice;

    _cachedOneTimePriceEls.forEach(function(el) { updateMoneySpan(el, tierPrice); });
    _cachedSubscriptionPriceEls.forEach(function(el) { updateMoneySpan(el, subPrice); });

    if (_cachedMainPriceEl) {
      var displayPrice = isSubscriptionActive() ? subPrice : tierPrice;
      updateMoneySpan(_cachedMainPriceEl, displayPrice);
    }

    // Re-apply after delay to fight Conversion Bear
    setTimeout(function() {
      _cachedOneTimePriceEls.forEach(function(el) { updateMoneySpan(el, tierPrice); });
      _cachedSubscriptionPriceEls.forEach(function(el) { updateMoneySpan(el, subPrice); });
      if (_cachedMainPriceEl) {
        var displayPrice = isSubscriptionActive() ? subPrice : tierPrice;
        updateMoneySpan(_cachedMainPriceEl, displayPrice);
      }
    }, 300);
  }

  // ---- QtyInputEl: handles +/- buttons ----
  class QtyInputEl extends HTMLElement {
    constructor() {
      super();
      this.input = null;
      this.plusBtn = null;
      this.minusBtn = null;
    }

    connectedCallback() {
      this.input = this.querySelector("input[name=quantity]");
      this.plusBtn = this.querySelector(".qty-input-plus");
      this.minusBtn = this.querySelector(".qty-input-minus");

      if (!this.input || !this.plusBtn || !this.minusBtn) return;

      this.plusBtn.addEventListener("click", () => {
        this.input.value = parseInt(this.input.value, 10) + 1;
        this.input.dispatchEvent(new Event("input", { bubbles: true }));
        this.input.dispatchEvent(new Event("change", { bubbles: true }));
      });

      this.minusBtn.addEventListener("click", () => {
        let val = parseInt(this.input.value, 10) - 1;
        if (val < 1) val = 1;
        this.input.value = val;
        this.input.dispatchEvent(new Event("input", { bubbles: true }));
        this.input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    disconnectedCallback() { }

    get quantity() {
      return this.input ? this.input.value : 0;
    }
  }

  if (!customElements.get("qty-table-input")) {
    customElements.define("qty-table-input", QtyInputEl);
  }

  // ---- QtyTableFormEl: manages price display & quantity sync ----
  class QtyTableFormEl extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Try both: custom element <qty-table> OR plain table .gridiscstbl
      this.table = this.querySelector("qty-table") || this.querySelector("table.gridiscstbl") || this.querySelector(".gridiscstbl");
      this.sliderInput = this.querySelector("qty-table-input input[name=quantity]") || this.querySelector("input[name=quantity]");
      this.quantityInput = this.querySelector(".sliderqty");
      this.totalPriceInput = document.getElementById("sliderttl");

      if (!this.table || !this.sliderInput) return;

      this.quantity = parseInt(this.sliderInput.value, 10) || 1;
      this.discountedPrice =
        parseFloat(
          this.table
            .querySelector("[data-tier-price]")
            ?.getAttribute("data-tier-price")
        ) || 0;
      this.basePrice =
        parseFloat(
          this.table
            .querySelector("[data-base-price]")
            ?.getAttribute("data-base-price")
        ) || 0;

      // %kriz customize - Initial bulk price update
      const initialRow = this.table.querySelector("tbody tr.actv");
      if (initialRow) {
        const bulkPrice = initialRow.getAttribute("data-bulk-price") || 0;
        const bulkPriceInput = document.getElementById("BulkOriginalPrice");
        if (bulkPriceInput) bulkPriceInput.value = bulkPrice;
      }

      // Listen on raw input
      this.sliderInput.addEventListener("input", () => {
        this.quantity = parseInt(this.sliderInput.value, 10) || 1;
        if (this.table.updateActiveRow) this.table.updateActiveRow(this.quantity);
        this.updatePriceFromInput(this.quantity);
        this.updateText();
      });

      this.sliderInput.addEventListener("change", () => {
        this.quantity = parseInt(this.sliderInput.value, 10) || 1;
        if (this.table.updateActiveRow) this.table.updateActiveRow(this.quantity);
        this.updatePriceFromInput(this.quantity);
        this.updateText();
      });

      this.table.addEventListener("pricing-table-select", (event) => {
        this.setQuantity(event.target);
        this.updatePriceFromTable(event.target);
        this.updateText();
      });

      this.pointsText = document.querySelector(".login-to-earn-points");
      this.pointsValue = this.pointsText?.querySelector(".earn-atLeast-points");
      this.pointsAmount = this.pointsText?.querySelector(".amt-points-earned");
      this.savedAmount = this.querySelector(".qty-table-saved-amount");

      // %kriz customize - Listen for Seal Subscription toggle
      this._setupSubscriptionListener();
    }

    // %kriz customize - Watch for subscription toggle
    _setupSubscriptionListener() {
      var self = this;

      // General click listener - catches clicks on any purchase option radio/button
      document.addEventListener('click', function(e) {
        var target = e.target.closest('[aria-label*="Subscribe"]') ||
                     e.target.closest('[aria-label*="One-time"]') ||
                     e.target.closest('[role="radio"]');
        if (target) {
          setTimeout(function() { self._onSubscriptionChange(); }, 200);
          setTimeout(function() { self._onSubscriptionChange(); }, 500);
        }
      });

      // Listen for selling_plan value changes
      document.addEventListener('change', function(e) {
        if (e.target.name && e.target.name.includes('selling_plan')) {
          setTimeout(function() { self._onSubscriptionChange(); }, 100);
        }
      });

      // Poll selling_plan input for programmatic changes
      var sellingPlanInput = document.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput) {
        var lastValue = sellingPlanInput.value;
        setInterval(function() {
          if (sellingPlanInput.value !== lastValue) {
            lastValue = sellingPlanInput.value;
            self._onSubscriptionChange();
          }
        }, 300);
      }
    }

    _onSubscriptionChange() {
      var selectedRow = this.table.querySelector("tbody tr.actv");
      if (selectedRow) {
        this.discountedPrice =
          parseFloat(
            selectedRow.querySelector("[data-tier-price]")?.getAttribute("data-tier-price")
          ) || 0;
      }
      this._calculateAndDisplayTotal(this.quantity, this.discountedPrice);
      this.updateText();
    }

    setQuantity(selectedRow) {
      this.quantity = parseInt(selectedRow.getAttribute("data-qty"), 10) || 0;
      if (this.sliderInput) this.sliderInput.value = this.quantity;
      if (this.quantityInput && this.quantityInput !== this.sliderInput) {
        this.quantityInput.value = this.quantity;
      }
    }

    // %kriz customize - Centralized price calculation
    _calculateAndDisplayTotal(qty, tierPrice) {
      var subActive = isSubscriptionActive();
      var subDiscount = getSubscriptionDiscount();

      var effectivePrice = tierPrice;
      if (subActive && hasSubscription() && subDiscount > 0) {
        effectivePrice = tierPrice * (1 - subDiscount);
      }

      var totalPrice = qty * effectivePrice;
      if (this.totalPriceInput) {
        this.totalPriceInput.value = "$" + totalPrice.toFixed(2);
      }

      // Update Seal widget prices
      updateSealWidgetPrice(tierPrice);
    }

    updatePriceFromTable(selectedRow) {
      this.discountedPrice =
        parseFloat(
          selectedRow.querySelector("[data-tier-price]")?.getAttribute("data-tier-price")
        ) || 0;
      this.quantity = parseInt(selectedRow.getAttribute("data-qty"), 10) || 0;

      const bulkPrice = selectedRow.getAttribute("data-bulk-price") || 0;
      const bulkPriceInput = document.getElementById("BulkOriginalPrice");
      if (bulkPriceInput) bulkPriceInput.value = bulkPrice;

      this._calculateAndDisplayTotal(this.quantity, this.discountedPrice);
    }

    updatePriceFromInput(selectedQty) {
      const selectedRow = this.table.querySelector("tbody tr.actv");
      if (selectedRow) {
        this.discountedPrice =
          parseFloat(
            selectedRow.querySelector("[data-tier-price]")?.getAttribute("data-tier-price")
          ) || 0;

        const bulkPrice = selectedRow.getAttribute("data-bulk-price") || 0;
        const bulkPriceInput = document.getElementById("BulkOriginalPrice");
        if (bulkPriceInput) bulkPriceInput.value = bulkPrice;
      }
      this._calculateAndDisplayTotal(selectedQty, this.discountedPrice);
    }

    updateText() {
      var subActive = isSubscriptionActive();
      var subDiscount = getSubscriptionDiscount();
      var effectivePrice = this.discountedPrice;
      if (subActive && hasSubscription() && subDiscount > 0) {
        effectivePrice = this.discountedPrice * (1 - subDiscount);
      }

      const totalSavings = parseFloat(
        this.quantity * this.basePrice - this.quantity * effectivePrice
      ).toFixed(2);

      if (this.savedAmount) this.savedAmount.innerText = "$" + totalSavings;

      const points = parseInt(this.quantity * effectivePrice * 2, 10);
      if (this.pointsValue) {
        this.pointsValue.innerText = "$" + parseFloat(points / 100).toFixed(2);
      }
      if (this.pointsAmount) {
        this.pointsAmount.innerText = points + " Points";
      }
    }
  }

  if (!customElements.get("qty-table-form")) {
    customElements.define("qty-table-form", QtyTableFormEl);
  }

  // ---- QtyTableEl: manages row highlighting ----
  class QtyTableEl extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", (e) => {
        const row = e.target.closest("tbody tr");
        if (row && this.contains(row) && row.hasAttribute("data-qty")) {
          this.setActiveRow(row);
          row.dispatchEvent(new Event("pricing-table-select", { bubbles: true }));
        }
      });
    }

    connectedCallback() {
      this.refreshRows();
    }

    refreshRows() {
      this.rows = this.querySelectorAll("tbody tr");
    }

    setActiveRow(selectedRow) {
      this.refreshRows();
      this.rows.forEach((row) => {
        row.classList.remove("actv");
        row.setAttribute("aria-selected", "false");
      });
      selectedRow.classList.add("actv");
      selectedRow.setAttribute("aria-selected", "true");
    }

    updateActiveRow(selectedQty) {
      this.refreshRows();
      const quantity = parseInt(selectedQty, 10);
      let selectedRow = this.rows[0];

      for (const row of this.rows) {
        const rowQty = parseInt(row.getAttribute("data-qty"), 10);
        if (quantity >= rowQty) {
          selectedRow = row;
        }
      }

      this.setActiveRow(selectedRow);
    }
  }

  if (!customElements.get("qty-table")) {
    customElements.define("qty-table", QtyTableEl);
  }
})();

// ============================================================
// IIFE #2: FALLBACK - Document-level event delegation
// This is the PRIMARY mechanism on the live site where
// <qty-table> custom element does NOT exist.
// Queries BOTH "qty-table" AND ".gridiscstbl" selectors.
// ============================================================
(function () {
  // ---- Selector helpers: find table/row regardless of DOM structure ----
  // On backup/dev: <qty-table> > <div> > <table class="gridiscstbl">
  // On live: just <table class="gridiscstbl"> (no <qty-table> wrapper)
  var TABLE_SELECTORS = 'qty-table, table.gridiscstbl, .gridiscstbl table';
  var ROW_SELECTOR_LIST = [
    'qty-table tbody tr',
    'table.gridiscstbl tbody tr',
    '.gridiscstbl tbody tr'
  ];

  /** Find the closest matching row from click target */
  function findClickedRow(target) {
    for (var i = 0; i < ROW_SELECTOR_LIST.length; i++) {
      var row = target.closest(ROW_SELECTOR_LIST[i]);
      if (row && row.hasAttribute('data-qty')) return row;
    }
    // Ultimate fallback: any tbody tr with data-qty
    var row = target.closest('tbody tr[data-qty]');
    return row;
  }

  /** Find the table element that contains a given row */
  function findTableContainer(row) {
    // Try <qty-table> first
    var container = row.closest('qty-table');
    if (container) return container;
    // Try <table class="gridiscstbl">
    container = row.closest('table.gridiscstbl');
    if (container) return container;
    // Try <div class="gridiscstbl"> (wrapper)
    container = row.closest('.gridiscstbl');
    if (container) return container;
    // Fallback: closest table
    return row.closest('table');
  }

  /** Find the form wrapper that contains the table */
  function findFormContainer(row) {
    // Try <qty-table-form> first
    var container = row.closest('qty-table-form');
    if (container) return container;
    // On live: the form is the product form or a parent div
    // Try common Shopify product form containers
    container = row.closest('form[action*="/cart/add"]');
    if (container) return container;
    container = row.closest('.product-form');
    if (container) return container;
    // Fallback: use document as the container
    return document;
  }

  /** Find the bulk pricing table element on the page */
  function findBulkTable() {
    return document.querySelector('qty-table') ||
           document.querySelector('table.gridiscstbl') ||
           document.querySelector('.gridiscstbl table') ||
           document.querySelector('.gridiscstbl');
  }

  // Cache for price elements (shared with fallback)
  var _fbSubscriptionPriceEls = [];
  var _fbOneTimePriceEls = [];
  var _fbMainPriceEl = null;

  function fbFindPriceElements() {
    // Check if cached element is still in DOM (Seal may re-render)
    var needsSearch = _fbSubscriptionPriceEls.length === 0 || 
                      _fbSubscriptionPriceEls.some(function(el) { return !document.contains(el); }) ||
                      _fbOneTimePriceEls.some(function(el) { return !document.contains(el); });
    if (!needsSearch) return;

    _fbSubscriptionPriceEls = [];
    _fbOneTimePriceEls = [];

    _fbMainPriceEl = document.querySelector('.product__price .price-item--sale') ||
                     document.querySelector('.product__price span.money') ||
                     document.querySelector('.product__price .money');

    // Strategy 1: Direct CSS class query
    document.querySelectorAll('.sls-one-time-price span.seal-money, .sls-one-time-price span.money, .sls-one-time-price .sls-price span').forEach(function(el) { _fbOneTimePriceEls.push(el); });
    document.querySelectorAll('.sls-selling-plan-group-price:not(.sls-one-time-price) span.seal-money, .sls-selling-plan-group-price:not(.sls-one-time-price) span.money, .sls-selling-plan-group-price:not(.sls-one-time-price) .sls-price span').forEach(function(el) { _fbSubscriptionPriceEls.push(el); });

    // Strategy 2: Use sls-option-container with sls-active vs without
    if (_fbSubscriptionPriceEls.length === 0) {
      document.querySelectorAll('.sls-option-container.sls-active span.seal-money, .sls-option-container.sls-active span.money').forEach(function(el) { _fbSubscriptionPriceEls.push(el); });
      document.querySelectorAll('.sls-option-container:not(.sls-active) span.seal-money, .sls-option-container:not(.sls-active) span.money').forEach(function(el) { _fbOneTimePriceEls.push(el); });
    }

    // Strategy 3: Brute force - find seal-money spans by parent class
    if (_fbSubscriptionPriceEls.length === 0) {
      var allSealSpans = document.querySelectorAll('span.seal-money');
      allSealSpans.forEach(function(span) {
        if (span === _fbMainPriceEl) return;
        var parent = span.closest('.sls-one-time-price');
        if (parent) {
          if (!_fbOneTimePriceEls.includes(span)) _fbOneTimePriceEls.push(span);
        } else {
          var sealParent = span.closest('.sls-price-container') || span.closest('.sls-price');
          if (sealParent && !_fbSubscriptionPriceEls.includes(span)) {
             _fbSubscriptionPriceEls.push(span);
          }
        }
      });
    }

    // Strategy 4: Strict Sibling Crawler based on known Label Object
    if (_fbSubscriptionPriceEls.length === 0 || _fbOneTimePriceEls.length === 0) {
      var labels = document.querySelectorAll('.sls-selling-plan-group-name');
      
      labels.forEach(function(label) {
        var text = label.textContent.toLowerCase();
        var isSub = text.includes('subscribe');
        var isOt = text.includes('one-time') || text.includes('one time');
        if (!isSub && !isOt) return;

        var sibling = label.nextElementSibling;
        var foundPriceSpan = null;
        var depth = 0;
        
        while (sibling && depth < 3 && !foundPriceSpan) {
          if (sibling.tagName === 'DIV') {
            var innerSpans = sibling.querySelectorAll('span');
            for (var i = 0; i < innerSpans.length; i++) {
              var s = innerSpans[i];
              if (s.textContent.trim().match(/^\$\d/) && 
                  s !== _fbMainPriceEl &&
                  !s.id.includes('sliderttl') &&
                  !s.classList.contains('sls-discount-badge')) {
                 foundPriceSpan = s;
                 break;
              }
            }
          }
          sibling = sibling.nextElementSibling;
          depth++;
        }

        if (foundPriceSpan) {
           if (isSub && !_fbSubscriptionPriceEls.includes(foundPriceSpan)) _fbSubscriptionPriceEls.push(foundPriceSpan);
           if (isOt && !_fbOneTimePriceEls.includes(foundPriceSpan)) _fbOneTimePriceEls.push(foundPriceSpan);
        }
      });
    }
  }

  function fbUpdateMoneySpan(el, newPrice) {
    if (!el) return;
    var priceText = '$' + newPrice.toFixed(2);
    el.textContent = priceText;
    for (var i = 0; i < el.attributes.length; i++) {
      if (el.attributes[i].name.startsWith('data-currency-')) {
        el.setAttribute(el.attributes[i].name, priceText);
      }
    }
    el.setAttribute('data-currency-cad', priceText);
  }

  function fbGetDiscount() {
    // Try data attribute on qty-table
    var qtyTable = document.querySelector('qty-table[data-subscription-discount]');
    if (qtyTable) {
      var d = parseFloat(qtyTable.getAttribute('data-subscription-discount')) || 0;
      if (d > 0) return d / 100;
    }
    // Try data attribute on .gridiscstbl wrapper
    var gridWrapper = document.querySelector('.gridiscstbl[data-subscription-discount]');
    if (gridWrapper) {
      var d = parseFloat(gridWrapper.getAttribute('data-subscription-discount')) || 0;
      if (d > 0) return d / 100;
    }
    // Search page text
    if (document.body) {
      var match = document.body.textContent.match(/SAVE\s+(\d+)%/i);
      if (match) return parseInt(match[1], 10) / 100;
    }
    return 0.10;
  }

  function fbIsSubActive() {
    // Check Seal widget visual state first (updates instantly before inputs)
    var subRadio = document.querySelector('[aria-label*="Subscribe"][aria-checked="true"]');
    if (subRadio) return true;
    var otRadio = document.querySelector('[aria-label*="One-time"][aria-checked="true"]');
    if (otRadio) return false;

    // Fallback original check
    var pi = document.querySelector('input[name="selling_plan"]');
    if (pi && pi.value && pi.value !== '' && pi.value !== '0') return true;
    var ps = document.querySelector('select[name="selling_plan"]');
    if (ps && ps.value && ps.value !== '' && ps.value !== '0') return true;
    return false;
  }

  function fbHasSubscription() {
    var qtyTable = document.querySelector('qty-table[data-has-subscription]');
    if (qtyTable) return qtyTable.getAttribute('data-has-subscription') === 'true';
    var gridWrapper = document.querySelector('.gridiscstbl[data-has-subscription]');
    if (gridWrapper) return gridWrapper.getAttribute('data-has-subscription') === 'true';
    return !!document.querySelector('input[name="selling_plan"]');
  }

  function fbUpdateAllPrices(tierPrice) {
    if (!fbHasSubscription()) return;
    fbFindPriceElements();
    var discount = fbGetDiscount();
    var subPrice = discount > 0 ? tierPrice * (1 - discount) : tierPrice;

    _fbOneTimePriceEls.forEach(function(el) { fbUpdateMoneySpan(el, tierPrice); });
    _fbSubscriptionPriceEls.forEach(function(el) { fbUpdateMoneySpan(el, subPrice); });

    if (_fbMainPriceEl) {
      var displayPrice = fbIsSubActive() ? subPrice : tierPrice;
      fbUpdateMoneySpan(_fbMainPriceEl, displayPrice);
    }

    // Re-apply after delay for Conversion Bear / Seal re-render
    setTimeout(function() {
      _fbOneTimePriceEls.forEach(function(el) { fbUpdateMoneySpan(el, tierPrice); });
      _fbSubscriptionPriceEls.forEach(function(el) { fbUpdateMoneySpan(el, subPrice); });
      if (_fbMainPriceEl) {
        var displayPrice = fbIsSubActive() ? subPrice : tierPrice;
        fbUpdateMoneySpan(_fbMainPriceEl, displayPrice);
      }
    }, 300);
  }

  // Allow keyboard users to select a pricing tier.
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;

    var row = findClickedRow(e.target);
    if (!row || !row.hasAttribute("data-qty")) return;

    e.preventDefault();
    row.click();
  });

  // ================================================================
  // ROW CLICK HANDLER - works for both <qty-table> AND .gridiscstbl
  // ================================================================
  document.addEventListener("click", function (e) {
    // Find the clicked row using multiple selectors
    var row = findClickedRow(e.target);
    if (!row || !row.hasAttribute("data-qty")) return;

    // App bulk-pricing-table stores prices in cents; IIFE #3 bridges that template.
    // Skipping here avoids treating cents as dollars (bad total/savings + Seal price bugs).
    if (
      row.classList.contains('bulk-pricing-table__row') ||
      row.closest('bulk-pricing-form') ||
      row.closest('bulk-pricing-table')
    ) {
      return;
    }

    var tableContainer = findTableContainer(row);
    var formContainer = findFormContainer(row);
    if (!tableContainer) return;

    // 1. Highlight clicked row
    tableContainer.querySelectorAll("tbody tr").forEach(function (r) {
      r.classList.remove("actv");
      r.setAttribute("aria-selected", "false");
    });
    row.classList.add("actv");
    row.setAttribute("aria-selected", "true");

    // 2. Get quantity from row
    var qty = parseInt(row.getAttribute("data-qty"), 10) || 1;

    // 3. Update all quantity inputs
    var inputs = [];
    if (formContainer === document) {
      inputs = document.querySelectorAll('input[name="quantity"], input.sliderqty');
    } else {
      inputs = formContainer.querySelectorAll('input[name="quantity"], input.sliderqty');
    }
    inputs.forEach(function (input) {
      input.value = qty;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    // 4. Get tier price
    var tierPriceCell = row.querySelector("[data-tier-price]");
    var tierPrice = tierPriceCell ? parseFloat(tierPriceCell.getAttribute("data-tier-price")) || 0 : 0;

    // 5. Calculate effective price (with subscription discount if active)
    var effectivePrice = tierPrice;
    var discount = fbGetDiscount();
    if (fbIsSubActive() && discount > 0) {
      effectivePrice = tierPrice * (1 - discount);
    }

    // 6. Update Total Cost
    var totalInput = document.getElementById("sliderttl");
    if (totalInput) totalInput.value = "$" + (qty * effectivePrice).toFixed(2);

    // 7. Update BulkOriginalPrice
    var bulkPrice = row.getAttribute("data-bulk-price") || 0;
    var bulkInput = document.getElementById("BulkOriginalPrice");
    if (bulkInput) bulkInput.value = bulkPrice;

    // 8. Update savings
    var basePrice = 0;
    var basePriceEl = tableContainer.querySelector("[data-base-price]");
    // If not on the table itself, check parent wrapper
    if (!basePriceEl) {
      var wrapper = tableContainer.closest('.gridiscstbl[data-base-price]') ||
                    tableContainer.closest('[data-base-price]');
      if (wrapper) basePriceEl = wrapper;
    }
    if (basePriceEl) basePrice = parseFloat(basePriceEl.getAttribute("data-base-price")) || 0;
    var savings = (qty * basePrice - qty * effectivePrice).toFixed(2);
    var savedEl = formContainer !== document ? formContainer.querySelector(".qty-table-saved-amount") : document.querySelector(".qty-table-saved-amount");
    if (savedEl) savedEl.innerText = "$" + savings;

    // 9. Update loyalty points
    var points = parseInt(qty * effectivePrice * 2, 10);
    var pointsText = document.querySelector(".login-to-earn-points");
    if (pointsText) {
      var pointsValue = pointsText.querySelector(".earn-atLeast-points");
      var pointsAmount = pointsText.querySelector(".amt-points-earned");
      if (pointsValue) pointsValue.innerText = "$" + (points / 100).toFixed(2);
      if (pointsAmount) pointsAmount.innerText = points + " Points";
    }

    // 10. Update Seal widget prices
    fbUpdateAllPrices(tierPrice);
  });

  // ================================================================
  // QUANTITY INPUT CHANGE HANDLER
  // ================================================================
  document.addEventListener("input", function(e) {
    if (e.target.name === 'quantity' || e.target.classList.contains('sliderqty')) {
      setTimeout(function() {
        var table = findBulkTable();
        if (!table) return;
        
        var qty = parseInt(e.target.value, 10) || 1;

        // Update active row based on quantity
        var rows = table.querySelectorAll('tbody tr[data-qty]');
        if (!rows.length) return;

        var selectedRow = rows[0];
        rows.forEach(function(row) {
          var rowQty = parseInt(row.getAttribute('data-qty'), 10);
          if (qty >= rowQty) selectedRow = row;
        });

        // Highlight the correct row
        rows.forEach(function(row) {
          row.classList.remove('actv');
          row.setAttribute('aria-selected', 'false');
        });
        selectedRow.classList.add('actv');
        selectedRow.setAttribute('aria-selected', 'true');

        // Get tier price from active row
        var tierPriceCell = selectedRow.querySelector('[data-tier-price]');
        if (!tierPriceCell) return;
        var tierPrice = parseFloat(tierPriceCell.getAttribute('data-tier-price')) || 0;

        // Calculate effective price
        var effectivePrice = tierPrice;
        var discount = fbGetDiscount();
        if (fbIsSubActive() && discount > 0) {
          effectivePrice = tierPrice * (1 - discount);
        }

        // Update Total Cost
        var totalInput = document.getElementById("sliderttl");
        if (totalInput) totalInput.value = "$" + (qty * effectivePrice).toFixed(2);

        // Update BulkOriginalPrice
        var bulkPrice = selectedRow.getAttribute("data-bulk-price") || 0;
        var bulkInput = document.getElementById("BulkOriginalPrice");
        if (bulkInput) bulkInput.value = bulkPrice;

        // Update savings
        var tableContainer = findTableContainer(selectedRow);
        var basePrice = 0;
        var basePriceEl = tableContainer ? tableContainer.querySelector("[data-base-price]") : null;
        if (!basePriceEl) {
          var wrapper = tableContainer ? tableContainer.closest('.gridiscstbl[data-base-price]') ||
                        tableContainer.closest('[data-base-price]') : null;
          if (wrapper) basePriceEl = wrapper;
        }
        if (!basePriceEl) basePriceEl = document.querySelector('[data-base-price]');
        if (basePriceEl) basePrice = parseFloat(basePriceEl.getAttribute("data-base-price")) || 0;
        var savings = (qty * basePrice - qty * effectivePrice).toFixed(2);
        var savedEl = document.querySelector(".qty-table-saved-amount");
        if (savedEl) savedEl.innerText = "$" + savings;

        // Update loyalty points
        var points = parseInt(qty * effectivePrice * 2, 10);
        var pointsText = document.querySelector(".login-to-earn-points");
        if (pointsText) {
          var pointsValue = pointsText.querySelector(".earn-atLeast-points");
          var pointsAmount = pointsText.querySelector(".amt-points-earned");
          if (pointsValue) pointsValue.innerText = "$" + (points / 100).toFixed(2);
          if (pointsAmount) pointsAmount.innerText = points + " Points";
        }

        // Update Seal widget prices
        fbUpdateAllPrices(tierPrice);
      }, 50);
    }
  });

  // ================================================================
  // SUBSCRIPTION TOGGLE HANDLER (fallback)
  // Watches for subscription toggle regardless of custom elements
  // ================================================================
  function fbOnSubscriptionChange() {
    var table = findBulkTable();
    if (!table) return;

    var activeRow = table.querySelector('tbody tr.actv');
    if (!activeRow) return;

    var tierPriceCell = activeRow.querySelector('[data-tier-price]');
    if (!tierPriceCell) return;
    var tierPrice = parseFloat(tierPriceCell.getAttribute('data-tier-price')) || 0;

    var qtyInput = document.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    // Calculate effective price
    var effectivePrice = tierPrice;
    var discount = fbGetDiscount();
    if (fbIsSubActive() && discount > 0) {
      effectivePrice = tierPrice * (1 - discount);
    }

    // Update Total Cost
    var totalInput = document.getElementById("sliderttl");
    if (totalInput) totalInput.value = "$" + (qty * effectivePrice).toFixed(2);

    // Update savings
    var basePrice = 0;
    var basePriceEl = document.querySelector('[data-base-price]');
    if (basePriceEl) basePrice = parseFloat(basePriceEl.getAttribute("data-base-price")) || 0;
    var savings = (qty * basePrice - qty * effectivePrice).toFixed(2);
    var savedEl = document.querySelector(".qty-table-saved-amount");
    if (savedEl) savedEl.innerText = "$" + savings;

    // Update loyalty points
    var points = parseInt(qty * effectivePrice * 2, 10);
    var pointsText = document.querySelector(".login-to-earn-points");
    if (pointsText) {
      var pointsValue = pointsText.querySelector(".earn-atLeast-points");
      var pointsAmount = pointsText.querySelector(".amt-points-earned");
      if (pointsValue) pointsValue.innerText = "$" + (points / 100).toFixed(2);
      if (pointsAmount) pointsAmount.innerText = points + " Points";
    }

    // Update Seal widget prices
    fbUpdateAllPrices(tierPrice);
  }

  // Click listener for subscription toggle
  document.addEventListener('click', function(e) {
    var target = e.target.closest('.sls-option-container') ||
                 e.target.closest('.seal-table') ||
                 e.target.closest('[aria-label*="Subscribe"]') ||
                 e.target.closest('[aria-label*="One-time"]') ||
                 e.target.closest('[role="radio"]');
    if (target) {
      setTimeout(fbOnSubscriptionChange, 50);
      setTimeout(fbOnSubscriptionChange, 150);
      setTimeout(fbOnSubscriptionChange, 300);
      setTimeout(fbOnSubscriptionChange, 600);
    }
  });

  // Change listener for selling_plan
  document.addEventListener('change', function(e) {
    if (e.target.name && e.target.name.includes('selling_plan')) {
      setTimeout(fbOnSubscriptionChange, 100);
    }
  });

  // Poll selling_plan for programmatic changes
  var _spInput = document.querySelector('input[name="selling_plan"]');
  if (_spInput) {
    var _lastSpValue = _spInput.value;
    setInterval(function() {
      if (_spInput.value !== _lastSpValue) {
        _lastSpValue = _spInput.value;
        fbOnSubscriptionChange();
      }
    }, 300);
  }

  // ================================================================
  // INITIAL LOAD: Wait for DOM + Seal widget, then apply initial state
  // ================================================================
  function fbInitialApply() {
    var table = findBulkTable();
    if (!table) return;

    var activeRow = table.querySelector('tbody tr.actv');
    if (!activeRow) return;

    var tierPriceCell = activeRow.querySelector('[data-tier-price]');
    if (!tierPriceCell) return;
    var tierPrice = parseFloat(tierPriceCell.getAttribute('data-tier-price')) || 0;

    // Apply initial Seal widget prices (Seal loads async, so retry)
    fbUpdateAllPrices(tierPrice);
  }

  // Apply on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(fbInitialApply, 500);
      setTimeout(fbInitialApply, 1500);
      setTimeout(fbInitialApply, 3000);
    });
  } else {
    // DOM already loaded
    setTimeout(fbInitialApply, 500);
    setTimeout(fbInitialApply, 1500);
    setTimeout(fbInitialApply, 3000);
  }
})();

// ============================================================
